<div *ngIf="notification() as notif" @fadeInOut class="fixed inset-0 flex items-end p-1 sm:items-start sm:p-6 pointer-events-none z-50">
  <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
    <div
      class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg shadow-xl"
      [ngClass]="{
        'bg-green-100 ring-black/5': notif.type === 'success',
        'bg-red-100 ring-red-400': notif.type === 'error',
      }"
    >
      <div class="p-4 flex items-start">
        <div class="shrink-0">
          <fa-icon *ngIf="notif.type === 'error'" class="text-center w-6 text-lg text-red-400" [icon]="errorIcon"></fa-icon>
          <fa-icon *ngIf="notif.type === 'success'" class="text-center w-6 text-lg text-green-400" [icon]="successIcon"></fa-icon>
        </div>
        <div class="ml-3 w-0 flex-1">
          <!-- <p class="text-sm font-medium text-gray-900">{{ notif.title }}</p> -->
          <p class="mt-1 text-sm text-gray-500">{{ notif.message }}</p>
        </div>
        <div class="ml-4 flex shrink-0">
          <button type="button" (click)="closeNotification()" class="rounded-md cursor-pointer bg-transparent text-gray-400 hover:text-gray-500">
            <span class="sr-only">Close</span>
            <svg class="size-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
